const ScheduleFooter = () => {
  return (
    <div className="bg-black py-5 px-4">
      <div className="flex items-center justify-between">
        <svg
          width="67"
          height="61"
          viewBox="0 0 67 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M50.2824 33.6893L35.1024 1C35.1024 1 34.8151 1 33.5226 1C32.7184 1 31.8144 1 31.8144 1L28.4243 8.59973C28.252 8.9418 28.1802 9.3136 28.2089 9.70028L29.128 27.4578L29.444 33.5405C29.444 33.5554 29.4296 33.5554 29.4296 33.5554H20.3245C20.3101 33.5554 20.2957 33.5405 20.3101 33.5257L25.1068 24.29C25.1068 24.2751 25.1212 24.2751 25.1355 24.29L27.2179 26.03C27.2323 26.0449 27.2467 26.03 27.2467 26.0152L27.06 21.7468V21.732L26.0978 20.8991C25.5233 20.4232 24.4776 19.7166 24.2913 19.7882C24.105 19.8599 23.1537 21.1222 22.8952 21.6279L16.6623 33.6149C16.3751 34.1652 16.3129 34.3491 15.8432 35.355C15.4765 36.1276 15.0955 36.4258 15.7418 36.7232C15.8423 36.7678 18.041 36.8422 18.1559 36.8422H30.5498C31.1242 36.8422 31.6843 36.5894 32.0865 36.1581C32.4886 35.7268 32.6896 35.1319 32.6609 34.537L32.4455 30.3876C32.4455 30.3728 32.4599 30.3579 32.4742 30.3728L39.7267 36.3663C40.1001 36.6786 40.574 36.8422 41.048 36.8422H48.717C48.8175 36.8422 49.0823 36.8422 49.1936 36.8422C50.0132 36.8422 50.8902 36.9272 51.3599 36.8422C51.3599 35.9028 50.5409 34.2395 50.2824 33.6893ZM46.6633 33.5554H41.4214H41.407L32.2157 25.9111C32.2157 25.9111 32.2157 25.8962 32.2013 25.8962L31.3684 9.81926C31.3684 9.81926 31.3684 9.81926 31.3684 9.80439L33.379 5.6699C33.3933 5.65502 33.4077 5.65502 33.4077 5.6699L46.6489 33.5257C46.6776 33.5405 46.6776 33.5554 46.6633 33.5554Z"
            fill="url(#paint0_linear_5913_50509)"
            stroke="url(#paint1_linear_5913_50509)"
            strokeWidth="0.716775"
          />
          <path
            d="M0.221462 56.8359L4.1524 46.8299H6.13932L10.0131 56.8359H8.16911L7.13992 54.0342H3.03745L2.00825 56.8359H0.221462ZM3.53775 52.6906H6.66821L5.09583 48.4595L3.53775 52.6906ZM11.6567 56.8359V55.6924L17.2744 48.245L11.6996 48.2879V46.8299H19.4471V47.9735L13.8438 55.4208L19.5329 55.3779V56.8359H11.6567ZM26.3348 56.9932C25.6296 56.9932 24.9673 56.8645 24.3479 56.6072C23.738 56.3404 23.1996 55.9735 22.7326 55.5066C22.2752 55.0301 21.9178 54.4821 21.6605 53.8627C21.4032 53.2338 21.2746 52.5572 21.2746 51.8329C21.2746 51.1087 21.4032 50.4368 21.6605 49.8174C21.9178 49.1885 22.2752 48.6405 22.7326 48.1736C23.1996 47.6971 23.738 47.3302 24.3479 47.0729C24.9673 46.8061 25.6296 46.6727 26.3348 46.6727C27.04 46.6727 27.6975 46.8061 28.3074 47.0729C28.9268 47.3302 29.4652 47.6971 29.9227 48.1736C30.3896 48.6405 30.7517 49.1885 31.009 49.8174C31.2663 50.4368 31.395 51.1087 31.395 51.8329C31.395 52.5572 31.2663 53.2338 31.009 53.8627C30.7517 54.4821 30.3896 55.0301 29.9227 55.5066C29.4652 55.9735 28.9268 56.3404 28.3074 56.6072C27.6975 56.8645 27.04 56.9932 26.3348 56.9932ZM26.3348 55.4494C26.8017 55.4494 27.2353 55.3589 27.6356 55.1778C28.0358 54.9967 28.3836 54.7442 28.6791 54.4202C28.984 54.0867 29.2175 53.7007 29.3795 53.2624C29.551 52.824 29.6368 52.3475 29.6368 51.8329C29.6368 51.3183 29.551 50.8418 29.3795 50.4035C29.2175 49.9651 28.984 49.5839 28.6791 49.2599C28.3836 48.9264 28.0358 48.6691 27.6356 48.488C27.2353 48.307 26.8017 48.2165 26.3348 48.2165C25.8678 48.2165 25.4342 48.307 25.034 48.488C24.6338 48.6691 24.2812 48.9264 23.9762 49.2599C23.6713 49.5839 23.433 49.9651 23.2615 50.4035C23.0995 50.8418 23.0185 51.3183 23.0185 51.8329C23.0185 52.3475 23.0995 52.824 23.2615 53.2624C23.433 53.7007 23.6713 54.0867 23.9762 54.4202C24.2812 54.7442 24.6338 54.9967 25.034 55.1778C25.4342 55.3589 25.8678 55.4494 26.3348 55.4494ZM35.9205 55.3493H37.9074C38.5078 55.3493 39.0509 55.1969 39.537 54.8919C40.023 54.5774 40.4089 54.1534 40.6948 53.6197C40.9807 53.0861 41.1236 52.4905 41.1236 51.8329C41.1236 51.1659 40.9807 50.5703 40.6948 50.0461C40.4089 49.5125 40.023 49.0932 39.537 48.7882C39.0509 48.4738 38.5078 48.3165 37.9074 48.3165H35.9205V55.3493ZM34.2052 56.8359V46.8299H37.8645C38.5888 46.8299 39.2558 46.9586 39.8657 47.2159C40.4756 47.4731 41.0045 47.8305 41.4524 48.2879C41.9098 48.7358 42.2624 49.2647 42.5102 49.8746C42.7579 50.475 42.8818 51.1277 42.8818 51.8329C42.8818 52.5381 42.7579 53.1956 42.5102 53.8055C42.2624 54.4059 41.9098 54.9348 41.4524 55.3922C41.0045 55.8401 40.4756 56.1927 39.8657 56.45C39.2558 56.7073 38.5888 56.8359 37.8645 56.8359H34.2052ZM45.6157 56.8359V46.8299H47.3311V51.0324H52.3055V46.8299H54.0208V56.8359H52.3055V52.5619H47.3311V56.8359H45.6157ZM56.1101 56.8359L60.0411 46.8299H62.028L65.9018 56.8359H64.0578L63.0286 54.0342H58.9261L57.8969 56.8359H56.1101ZM59.4264 52.6906H62.5569L60.9845 48.4595L59.4264 52.6906Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_5913_50509"
              x1="9.09351"
              y1="-0.889722"
              x2="50.6674"
              y2="39.4243"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFE600" />
              <stop offset="0.338542" stopColor="#09C153" />
              <stop offset="0.713542" stopColor="#1C70D2" />
              <stop offset="1" stopColor="#4B1CD2" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_5913_50509"
              x1="9.09351"
              y1="-0.889722"
              x2="50.6674"
              y2="39.4243"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFE600" />
              <stop offset="0.338542" stopColor="#09C153" />
              <stop offset="0.713542" stopColor="#1C70D2" />
              <stop offset="1" stopColor="#4B1CD2" />
            </linearGradient>
          </defs>
        </svg>

        <div className="flex items-center justify-start gap-4">
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5913_50518)">
              <path
                d="M22 19.55C22.917 18.613 24.111 18 25.5 18C26.9587 18 28.3576 18.5795 29.3891 19.6109C30.4205 20.6424 31 22.0413 31 23.5V31H29V23.5C29 22.5717 28.6313 21.6815 27.9749 21.0251C27.3185 20.3687 26.4283 20 25.5 20C24.5717 20 23.6815 20.3687 23.0251 21.0251C22.3687 21.6815 22 22.5717 22 23.5V31H20V18.5H22V19.55ZM15 16.5C14.6022 16.5 14.2206 16.342 13.9393 16.0607C13.658 15.7794 13.5 15.3978 13.5 15C13.5 14.6022 13.658 14.2206 13.9393 13.9393C14.2206 13.658 14.6022 13.5 15 13.5C15.3978 13.5 15.7794 13.658 16.0607 13.9393C16.342 14.2206 16.5 14.6022 16.5 15C16.5 15.3978 16.342 15.7794 16.0607 16.0607C15.7794 16.342 15.3978 16.5 15 16.5ZM14 18.5H16V31H14V18.5Z"
                fill="url(#paint0_linear_5913_50518)"
              />
            </g>
            <rect x="0.5" y="0.5" width="43" height="43" stroke="white" />
            <defs>
              <linearGradient
                id="paint0_linear_5913_50518"
                x1="3.35686"
                y1="5.5"
                x2="46.1034"
                y2="48.0392"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE600" />
                <stop offset="0.338542" stopColor="#09C153" />
                <stop offset="0.713542" stopColor="#1C70D2" />
                <stop offset="1" stopColor="#4B1CD2" />
              </linearGradient>
              <clipPath id="clip0_5913_50518">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(10 10)"
                />
              </clipPath>
            </defs>
          </svg>
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5913_50520)">
              <path
                d="M25.2995 15.5482C24.5395 15.548 23.8098 15.8463 23.2674 16.3787C22.7251 16.9112 22.4134 17.6353 22.3995 18.3952L22.3715 19.9702C22.3699 20.0547 22.3504 20.138 22.3143 20.2145C22.2782 20.291 22.2264 20.359 22.1622 20.414C22.098 20.4691 22.0228 20.5099 21.9417 20.5339C21.8606 20.5579 21.7754 20.5645 21.6915 20.5532L20.1305 20.3412C18.0765 20.0612 16.1085 19.1152 14.2205 17.5422C13.6225 20.8522 14.7905 23.1452 17.6035 24.9142L19.3505 26.0122C19.4335 26.0643 19.5025 26.136 19.5514 26.221C19.6003 26.306 19.6276 26.4017 19.6309 26.4996C19.6343 26.5976 19.6136 26.6949 19.5706 26.7831C19.5277 26.8712 19.4638 26.9474 19.3845 27.0052L17.7925 28.1682C18.7395 28.2272 19.6385 28.1852 20.3845 28.0372C25.1025 27.0952 28.2395 23.5452 28.2395 17.6892C28.2395 17.2112 27.2275 15.5482 25.2995 15.5482ZM20.3995 18.3582C20.417 17.3942 20.7184 16.4568 21.2661 15.6634C21.8138 14.8699 22.5833 14.2557 23.4784 13.8975C24.3736 13.5394 25.3544 13.4532 26.2983 13.6499C27.2421 13.8466 28.107 14.3173 28.7845 15.0032C29.4955 14.9982 30.1005 15.1782 31.4535 14.3582C31.1185 15.9982 30.9535 16.7102 30.2395 17.6892C30.2395 25.3312 25.5425 29.0472 20.7765 29.9982C17.5085 30.6502 12.7565 29.5792 11.3945 28.1572C12.0885 28.1032 14.9085 27.8002 16.5385 26.6072C15.1595 25.6982 9.67053 22.4682 13.2775 13.7842C14.9705 15.7612 16.6875 17.1072 18.4275 17.8212C19.5855 18.2962 19.8695 18.2862 20.4005 18.3592L20.3995 18.3582Z"
                fill="url(#paint0_linear_5913_50520)"
              />
            </g>
            <rect x="0.5" y="0.5" width="43" height="43" stroke="white" />
            <defs>
              <linearGradient
                id="paint0_linear_5913_50520"
                x1="-2.79041"
                y1="1.99817"
                x2="37.4006"
                y2="60.4326"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE600" />
                <stop offset="0.338542" stopColor="#09C153" />
                <stop offset="0.713542" stopColor="#1C70D2" />
                <stop offset="1" stopColor="#4B1CD2" />
              </linearGradient>
              <clipPath id="clip0_5913_50520">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(10 10)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <div className="flex items-center justify-start gap-40 text-white mt-5">
        <div className="flex flex-col gap-4">
          <p>Platform</p>
          <p>Services</p>
          <p>Blogs</p>
        </div>
        <div className="flex flex-col gap-4">
          <p>About Us</p>
          <p>Contact Us</p>
          <p>FAQ</p>
        </div>
      </div>

      <div className="border border-white my-6"></div>

      <p className="text-white">Terms and Conditions Privacy Policy © 2023</p>
    </div>
  );
};

export default ScheduleFooter;
